var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"main-layout__content"},[_c('div',{staticClass:"content"},[_c('h1',{directives:[{name:"t",rawName:"v-t",value:('not_found'),expression:"'not_found'"}],staticClass:"page-title"})])])}
var staticRenderFns = []

export { render, staticRenderFns }